import Rule from '../Rule'
import Rules from "../Rules";
import {DeviceConfig} from "../../services/DeviceConfigService/DeviceConfig";

export default class EnvirotainerRules extends Rules {
  public setTemperature: number;
  public lowInternalTemp: number;
  public highInternalTemp: number;
  public lowAmbientTemp: number;
  public highAmbientTemp: number;
  public lowInternalHumidity: number;
  public highInternalHumidity: number;
  public lowAmbientHumidity: number;
  public highAmbientHumidity: number;
  public lowBattery: number;


  constructor(data: any, deviceId: string) {
    super(data);
    this.setTemperature = data['setTemp'];
    this.lowInternalTemp = data['lowInternalTemp'];
    this.highInternalTemp = data['highInternalTemp'];
    this.lowAmbientTemp = data['lowAmbientTemp'];
    this.highAmbientTemp = data['highAmbientTemp'];
    this.lowInternalHumidity = data['lowInternalHumidity'];
    this.highInternalHumidity = data['highInternalHumidity'];
    this.lowAmbientHumidity = data['lowAmbientHumidity'];
    this.highAmbientHumidity = data['highAmbientHumidity'];
    this.lowBattery = data['lowBattery'];


    this.rules.push(new Rule('setTemp', DeviceConfig.getEnvirotainerRulesConfig(), this.setTemperature));
    this.rules.push(new Rule('InternalTemp', DeviceConfig.getEnvirotainerRulesConfig(),[this.lowInternalTemp, this.highInternalTemp]));
    this.rules.push(new Rule('AmbientTemp', DeviceConfig.getEnvirotainerRulesConfig(),[this.lowAmbientTemp, this.highAmbientTemp]));
    if (/^(ENV-)?(RLP)\w+$/.test(deviceId )) {
      this.rules.push(new Rule('InternalHumidity', DeviceConfig.getEnvirotainerRulesConfig(),[this.lowInternalHumidity, this.highInternalHumidity]));
      this.rules.push(new Rule('AmbientHumidity', DeviceConfig.getEnvirotainerRulesConfig(),[this.lowAmbientHumidity, this.highAmbientHumidity]));

    }
    this.rules.push(new Rule('lowBattery', DeviceConfig.getEnvirotainerRulesConfig(),this.lowBattery));
  }
}
